/**
 * @class
 * @description Wrapper class that injects our modified hlsjs loader in a clappr instance.
 * @exports Clappr
 */
export default class Clappr {
    /**
     * Constructs Clappr adapter.
     * @param {Object} player Clappr player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        let hlsconfig = null;
        player.loader.playbackPlugins.forEach((plugin) => {
            var _a;
            if ((_a = plugin.HLSJS) === null || _a === void 0 ? void 0 : _a.DefaultConfig) {
                hlsconfig = plugin.HLSJS.DefaultConfig;
            }
            else if (plugin.name === 'DashShakaPlayback') {
                new (Clappr._adapters.getLoaders().LoaderShaka)(plugin.shakaPlayer);
            }
        });
        try {
            if (hlsconfig) {
                hlsconfig.loader = Clappr._adapters.getLoaders().LoaderHlsjs;
            }
        }
        catch (err) {
            console.error(err);
        }
    }
}
